// @ts-nocheck

import React from 'react';
import { CSSTransition } from 'react-transition-group';
import styled, { keyframes } from 'styled-components';

import Formatter from '../../../../i18n/formatter';
import { getCurrency } from '../../../../i18n/l10n';
import { GRRoundWonTagImgPath } from '../../assets/img';
import useGRRoundContext from '../../hooks/useGRRoundContext';

const appearAnim = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const ribbonImgRatio = 0.37184873949;
const ribbonWidth = 70; // %
const Wrapper = styled.div`
  width: ${ribbonWidth}%;
  padding-bottom: ${ribbonWidth * ribbonImgRatio}%;
  background-image: url(${GRRoundWonTagImgPath});
  background-size: contain;
  background-repeat: no-repeat;

  &.gr-won-round-tag-appearance-transition-enter {
    animation: ${appearAnim} 300ms ease-in-out forwards;
  }
  &.gr-won-round-tag-appearance-transition-exit {
    animation: ${appearAnim} 300ms ease-in-out forwards reverse;
  }
`;

const WonAmount = styled.div`
  position: absolute;
  left: 3%;
  top: 0;
  width: 76%;
  height: 65%;
  font-size: 2.6em;

  display: flex;
  justify-content: center;
  align-items: center;
`;

type GRRoundWonTagProps = {
  className?: string;
  wonAmount?: number;
};

const GRRoundWonTag = ({ className = '', wonAmount = 100 }: GRRoundWonTagProps) => {
  const { isWon } = useGRRoundContext();

  return (
    <CSSTransition
      in={isWon}
      classNames="gr-won-round-tag-appearance-transition"
      timeout={300}
      mountOnEnter
      unmountOnExit
    >
      <Wrapper className={className}>
        <WonAmount>
          {Formatter.formatBankroll(wonAmount * 100, getCurrency(), (wonAmount * 100) % 100 === 0 || wonAmount >= 1000)}
        </WonAmount>
      </Wrapper>
    </CSSTransition>
  );
};

export default GRRoundWonTag;
